import { createAction } from '@reduxjs/toolkit'

export const DATABASE_LOAD_TABLE = 'DATABASE_LOAD_TABLE'
export const DATABASE_LOAD_OPTIONS = 'DATABASE_LOAD_OPTIONS'
export const DATABASE_CREATE_ROW = 'DATABASE_CREATE_ROW'
export const DATABASE_UPDATE_ROW = 'DATABASE_UPDATE_ROW'
export const DATABASE_DELETE_ROW = 'DATABASE_DELETE_ROW'

export const databaseLoadTable = createAction(DATABASE_LOAD_TABLE)
export const databaseLoadOptions = createAction(DATABASE_LOAD_OPTIONS)
export const databaseCreateRow = createAction(DATABASE_CREATE_ROW)
export const databaseUpdateRow = createAction(DATABASE_UPDATE_ROW)
export const databaseDeleteRow = createAction(DATABASE_DELETE_ROW)
